import type { LabsContext } from './types';

export const NO_UNIT = 'none';
export const NO_LABS_UNITS_MESSAGE = 'None of your units have Labs turned on yet. Ask your teacher to turn it on.';

export function initialUnitChoice(labs: Pick<LabsContext, 'requiresLabsUnit' | 'units'>): string {
  if (!labs.requiresLabsUnit) return NO_UNIT;
  return labs.units.length === 1 ? labs.units[0].id : '';
}

export function unitChoiceToId(choice: string): string | null {
  return !choice || choice === NO_UNIT ? null : choice;
}

export function hasNoLabsUnits(labs: Pick<LabsContext, 'requiresLabsUnit' | 'units'>): boolean {
  return labs.requiresLabsUnit && labs.units.length === 0;
}
